import VS from 'constants/ValidationShema';
import getObjectValue from "libs/getObjectValue";

export default  () => VS.object({
    step: VS.any().strip(),
    orderDealing: VS.any().strip(),
    primaryDealing: VS.any().strip(),
    partnershipDealing: VS.any().strip(),
    form: VS.lazy(form => {
        const refersTo = getObjectValue("basicData.refersTo", form, null);
        const realizationType = refersTo === "Order" ? getObjectValue("realizationType.orderRealizationType", form, null) : (refersTo === "FrameworkAgreement" ? getObjectValue("realizationType.frameworkRealizationType", form, null) : null)
        const partialOffers = getObjectValue("orderObject.partialOffers", form, null);
        const orderType = getObjectValue("orderObject.orderType", form, null);

        const realization_primary_1 = (refersTo === "Order" && realizationType === "1.1.1") || (refersTo === "FrameworkAgreement" && realizationType === "11.1.1");
        const realization_primary_2 = (refersTo === "Order" && realizationType === "1.1.2") || (refersTo === "FrameworkAgreement" && realizationType === "11.1.2");
        const realization_primary_3 = (refersTo === "Order" && realizationType === "1.1.3") || (refersTo === "FrameworkAgreement" && realizationType === "11.1.3");
        const realization_partnership_2 = (refersTo === "Order" && realizationType === "1.2") || (refersTo === "FrameworkAgreement" && realizationType === "11.2");

        const primaryRealizationType = realization_primary_1 || realization_primary_2 || realization_primary_3;

        const criteriaValidator = (criteriaWeightStrategy) => VS.arrayOfShape({
            type: VS.string(),
            qualityCriterionType: VS.any().when("type", {is: "QUALITY", then: VS.string(), otherwise: VS.any().strip()}),
            criterionName: VS.stringMax(1000),
            criterionPctgWeight: VS.any().when("type", {is: (x) => criteriaWeightStrategy === "1", then: VS.amountMax100(), otherwise: VS.any().strip()}),
            criterionPktWeight: VS.any().when("type", {is: (x) => criteriaWeightStrategy === "2", then: VS.amountMax100(), otherwise: VS.any().strip()}),
            criterionOrder: VS.any().when("type", {is: (x) => criteriaWeightStrategy === "3", then: VS.amount(0, false), otherwise: VS.any().strip()})
        })

        const primaryLotValidator = VS.lazy(lot => {
            const criteriaWeightStrategy = !!lot ? lot.criteriaWeightStrategy : null;

            return VS.object({
                negotiationsPossible: VS.any().when("criteriaWeightStrategy", {
                    is: (x) => realization_primary_2,
                    then: VS.requiredBoolean(),
                    otherwise: VS.any().strip()
                }),
                evaluationMethodDescription: VS.any().when("criteriaWeightStrategy", {
                    is: (x) => realization_primary_1 || realization_primary_2,
                    then: VS.stringMaxNoRq(4000),
                    otherwise: VS.any().strip()
                }),
                criteriaWeightStrategy: VS.string(),
                criteriaEvaluationStrategy: VS.string(),
                evaluationSocialAspects3: VS.any().when("criteriaWeightStrategy", {
                    is: (x) => realization_primary_3,
                    then: VS.requiredBoolean(),
                    otherwise: VS.any().strip()
                }),
                evaluationSocialAspects3Info: VS.any().when("evaluationSocialAspects3", {
                    is: (x) => x === true,
                    then: VS.arrayRequired(),
                    otherwise: VS.any().strip()
                }),
                evaluationSocialAspects12: VS.any().when("criteriaWeightStrategy", {
                    is: (x) => realization_primary_1 || realization_primary_2,
                    then: VS.requiredBoolean(),
                    otherwise: VS.any().strip()
                }),
                evaluationSocialAspects12Info: VS.any().when("evaluationSocialAspects12", {
                    is: (x) => x === true && (realization_primary_1 || realization_primary_2),
                    then: VS.arrayRequired(),
                    otherwise: VS.any().strip()
                }),
                criteria: criteriaValidator(criteriaWeightStrategy)
            })
        })

        const partnershipLotValidator = VS.lazy(lot => {
            const criteriaWeightStrategy = !!lot ? lot.criteriaWeightStrategy : null;

            return VS.object({
                criteriaWeightStrategy: VS.string(),
                criteriaEvaluationStrategy: VS.string(),
                nonNegotiableRequirements: VS.string(4000),
                criteria: criteriaValidator(criteriaWeightStrategy)
            })
        })


        return VS.object({
            basicData: VS.object({
                refersTo: VS.string(),
                refersToSocialServices: VS.requiredBoolean(),
                name: VS.stringMax(200),
                tenderPlanRelated: VS.requiredBoolean(),
                tenderPlanNumber: VS.any().when("tenderPlanRelated", {is: (x) => x === true, then: VS.stringMax(30), otherwise: VS.any().strip()}),
                tenderPlanItemIdentities: VS.any().when("tenderPlanRelated", {is: (x) => x === true, then: VS.arrayRequired(), otherwise: VS.any().strip()}),
                onlyArt94Suppliers: VS.requiredBoolean(),
                art94Suppliers: VS.any().when("onlyArt94Suppliers", {is: (x) => x === true, then: VS.arrayRequired(), otherwise: VS.any().strip()}),
                onlyArt361Suppliers: VS.any().when("refersToSocialServices", {is: (x) => x === true, then: VS.requiredBoolean()}),
                ueFunded: VS.requiredBoolean(),
                ueProgramName: VS.any().when("ueFunded", {is: (x) => x === true, then: VS.stringMax(400), otherwise: VS.any().strip()})
            }),
            purchaserData: VS.object({
                phoneNumber: VS.stringMaxNoRq(100),
                faxNumber: VS.stringMaxNoRq(100),
                email: VS.emailMax(250),
                type: VS.string(),
                typeOther: VS.any().when("type", {is: "1.5", then: VS.stringMax(200), otherwise: VS.any().strip()}),
                activitySubject: VS.string(),
                activitySubjectOther: VS.any().when("activitySubject", {is: "11", then: VS.stringMax(200), otherwise: VS.any().strip()}),
                role: VS.string(),
                together: VS.any().when("role", {
                    is: "wspolnie", then: VS.object({
                        togetherCount: VS.integerMinMax(1, 100),
                        togetherDuties: VS.stringMax(1000),
                        togetherRegulations: VS.stringMaxNoRq(1000),
                        list: VS.arrayOfShape({
                            name: VS.stringMax(300),
                            branch: VS.stringMaxNoRq(300),
                            nationalIdNumber: VS.stringMax(100),
                            street: VS.stringMax(100),
                            city: VS.stringMax(100),
                            postCode: VS.stringMax(20),
                            state: VS.any().when("country", {is: "PL", then: VS.string(), otherwise: VS.any().strip()}),
                            country: VS.string(),
                            nuts3: VS.any().when("country", {is: "PL", then: VS.string(), otherwise: VS.any()}),
                            phone: VS.stringMaxNoRq(100),
                            fax: VS.stringMaxNoRq(100),
                            email: VS.emailMax(250),
                            www: VS.urlMax(250)
                        })

                    }), otherwise: VS.any().strip()
                }),
                entrusted: VS.any().when("role", {
                    is: "powierzony", then: VS.object({
                        name: VS.stringMax(300),
                        nationalIdNumber: VS.stringMax(100),
                        street: VS.stringMax(100),
                        city: VS.stringMax(100),
                        postCode: VS.stringMax(20),
                        state: VS.any().when("country", {is: "PL", then: VS.string(), otherwise: VS.any().strip()}),
                        country: VS.string(),
                        nuts3: VS.any().when("country", {is: "PL", then: VS.string(), otherwise: VS.any()}),
                        phone: VS.stringMaxNoRq(100),
                        fax: VS.stringMaxNoRq(100),
                        email: VS.emailMax(250),
                        www: VS.urlMax(250)
                    }), otherwise: VS.any().strip()
                })
            }),
            realizationType: VS.object({
                orderRealizationType: VS.any().when("frameworkRealizationType", {
                    is: (x) => refersTo === "Order",
                    then: VS.string(),
                    otherwise: VS.any().strip()
                }),
                frameworkRealizationType: VS.any().when("orderRealizationTypes", {
                    is: (x) => refersTo === "FrameworkAgreement",
                    then: VS.string(),
                    otherwise: VS.any().strip()
                })
            }),
            documentsAccess: VS.object({
                ezamowieniaDemand: VS.requiredBoolean(),
                www: VS.urlMax(250),
                restrictedAccess: VS.requiredBoolean(),
                restrictedAccessInfo: VS.any().when("restrictedAccess", {is: (x) => x === true, then: VS.stringMax(4000), otherwise: VS.any().strip()}),
                electronicOffersOnly: VS.requiredBoolean(),
                electronicOffersInfo: VS.any().when("electronicOffersOnly", {is: (x) => x === true, then: VS.stringMax(1000), otherwise: VS.any().strip()}),
                electronicOffersRequirements: VS.any().when("electronicOffersOnly", {is: (x) => x === true, then: VS.stringMax(4000)}),
                toolsWww: VS.urlMaxOptional(250),
                toolsNotWidelyAvailable: VS.requiredBoolean(),
                notWidelyAvailableToolsInfo: VS.any().when("toolsNotWidelyAvailable", {is: (x) => x === true, then: VS.stringMax(4000), otherwise: VS.any().strip()}),
                offerCatalog: VS.string(),
                notElectronicOffersReason: VS.any().when("electronicOffersOnly", {
                    is: (x) => x === false,
                    then: VS.arrayRequired(),
                    otherwise: VS.any().strip()
                }),
                notElectronicOffersMethod: VS.any().when("electronicOffersOnly", {is: (x) => x === false, then: VS.stringMax(4000), otherwise: VS.any().strip()}),
                offerLang: VS.arrayRequired(),
                rodoInfo: VS.stringMaxNoRq(4000),
                rodoLimitations: VS.stringMaxNoRq(4000),
                offerCatalogUsage: VS.any().when("ezamowieniaDemand", {
                    is: (x) => refersTo === "FrameworkAgreement",
                    then: VS.requiredBoolean(),
                    otherwise: VS.any().strip()
                })
            }),
            orderObject: VS.object({
                marketConsultations: VS.requiredBoolean(),
                number: VS.stringMaxNoRq(100),
                orderType: VS.string(),
                dividedIntoLots: VS.any().when("orderType", {is: (x) => refersTo === "Order", then: VS.requiredBoolean(), otherwise: VS.any().strip()}),
                lotsValueNet: VS.any().when("orderType", {is: (x) => refersTo === "Order", then: VS.amountOptional(), otherwise: VS.any().strip()}),
                lotsValueNetCurrency: VS.any().when("orderType", {is: (x) => refersTo === "Order", then: VS.any(), otherwise: VS.any().strip()}),
                orderValueNet: VS.any().when(["orderType", "dividedIntoLots"], {is: (orderType, dividedIntoLots) => refersTo === "Order" && dividedIntoLots === true, then: VS.amountOptional(), otherwise: VS.any().strip()}),
                orderValueNetCurrency: VS.any().when(["orderType", "dividedIntoLots"], {is: (orderType, dividedIntoLots) => refersTo === "Order" && dividedIntoLots === true, then: VS.any(), otherwise: VS.any().strip()}),
                frameworkAgreementValueNet: VS.any().when("orderType", {
                    is: (x) => refersTo === "FrameworkAgreement",
                    then: VS.amountOptional(),
                    otherwise: VS.any().strip()
                }),
                frameworkAgreementValueNetCurrency: VS.any().when("orderType", {
                    is: (x) => refersTo === "FrameworkAgreement",
                    then: VS.any(), otherwise: VS.any().strip()
                }),
                partialOffers: VS.requiredBoolean(),
                dealingCount: VS.any().when("partialOffers", {is: (x) => x === true, then: VS.integerMinMax(2, 1000), otherwise: VS.any().strip()}),
                offerType: VS.any().when("partialOffers", {is: (x) => x === true, then: VS.string(), otherwise: VS.any().strip()}),
                dealingLimited: VS.any().when("partialOffers", {is: (x) => x === true, then: VS.requiredBoolean(), otherwise: VS.any().strip()}),
                dealingLimitPerSupplier: VS.any().when("dealingLimited", {
                    is: (x) => x === true,
                    then: VS.numberPositiveNoZero(),
                    otherwise: VS.any().strip()
                }),
                socialAspectsConsidered: VS.requiredBoolean(),
                socialAspects: VS.any().when("socialAspectsConsidered", {is: (x) => x === true, then: VS.arrayRequired(), otherwise: VS.any().strip()}),
                notDivided: VS.any().when("partialOffers", {
                    is: (x) => x === false, then: VS.object({
                        purchaserNeedsDescription: VS.any().when("mainCpv", {is: (x) => realization_primary_3, then: VS.stringMax(10000), otherwise: VS.any().strip()}),
                        innovationProductNeed: VS.any().when("mainCpv", {is: (x) => realization_partnership_2, then: VS.string(10000), otherwise: VS.any().strip()}),
                        orderSubjectDescription: VS.any().when("mainCpv", {
                            is: (x) => realization_primary_1 || realization_primary_2,
                            then: VS.stringMax(10000),
                            otherwise: VS.any().strip()
                        }),
                        mainCpv: VS.requiredObject(),
                        additionalCpv: VS.any(),
                        includesOptions: VS.requiredBoolean(),
                        includesOptionsInfo: VS.any().when("includesOptions", {is: (x) => x === true, then: VS.stringMax(4000), otherwise: VS.any().strip()}),
                        realizationPeriod: VS.string(),
                        realizationPeriodDateFrom: VS.any().when("realizationPeriod", {is: "DateFromTo", then: VS.dateTimeValid(), otherwise: VS.any().strip()}),
                        realizationPeriodDateTo: VS.any().when("realizationPeriod", {
                            is: (x) => x === "DateFromTo" || x === "DateTo",
                            then: VS.dateTimeValid(),
                            otherwise: VS.any().strip()
                        }),
                        realizationPeriodAmount: VS.any().when("realizationPeriod", {
                            is: (x) => x === "NumberOfDays" || x === "NumberOfMonths",
                            then: VS.string(),
                            otherwise: VS.any().strip()
                        }),
                        planRenewals: VS.requiredBoolean(),
                        planRenewalsInfo: VS.any().when("planRenewals", {is: (x) => x === true, then: VS.stringMax(4000), otherwise: VS.any().strip()}),
                        planOtherOrderForCurrentSupplier: VS.any().when("mainCpv", {is: (x) => orderType === "Works" || orderType === "Services", then: VS.requiredBoolean(), otherwise: VS.any()}),
                        planOtherOrderForCurrentSupplierInfo: VS.any().when("planOtherOrderForCurrentSupplier", {
                            is: (x) => x === true,
                            then: VS.stringMax(4000),
                            otherwise: VS.any().strip()
                        })
                    }), otherwise: VS.any().strip()
                }),
                divided: VS.any().when("partialOffers", {
                    is: (x) => x === true, then: VS.arrayOfShape({
                        dealingValue: VS.amountOptional(0, false),
                        dealingValueCurrency: VS.any(),
                        purchaserNeedsDescription: VS.any().when("mainCpv", {is: (x) => realization_primary_3, then: VS.stringMax(10000), otherwise: VS.any().strip()}),
                        innovationProductNeed: VS.any().when("mainCpv", {is: (x) => realization_partnership_2, then: VS.string(10000), otherwise: VS.any().strip()}),
                        orderSubjectDescription: VS.any().when("mainCpv", {
                            is: (x) => realization_primary_1 || realization_primary_2,
                            then: VS.stringMax(10000),
                            otherwise: VS.any().strip()
                        }),
                        mainCpv: VS.requiredObject(),
                        additionalCpv: VS.any(),
                        includesOptions: VS.requiredBoolean(),
                        includesOptionsInfo: VS.any().when("includesOptions", {is: (x) => x === true, then: VS.stringMax(4000), otherwise: VS.any().strip()}),
                        realizationPeriod: VS.string(),
                        realizationPeriodDateFrom: VS.any().when("realizationPeriod", {is: "DateFromTo", then: VS.dateTimeValid(), otherwise: VS.any().strip()}),
                        realizationPeriodDateTo: VS.any().when("realizationPeriod", {
                            is: (x) => x === "DateFromTo" || x === "DateTo",
                            then: VS.dateTimeValid(),
                            otherwise: VS.any().strip()
                        }),
                        realizationPeriodAmount: VS.any().when("realizationPeriod", {
                            is: (x) => x === "NumberOfDays" || x === "NumberOfMonths",
                            then: VS.string(),
                            otherwise: VS.any().strip()
                        }),
                        planRenewals: VS.requiredBoolean(),
                        planRenewalsInfo: VS.any().when("planRenewals", {is: (x) => x === true, then: VS.stringMax(4000), otherwise: VS.any().strip()}),
                        planOtherOrderForCurrentSupplier: VS.any().when("mainCpv", {is: (x) => orderType === "Works" || orderType === "Services", then: VS.requiredBoolean(), otherwise: VS.any()}),
                        planOtherOrderForCurrentSupplierInfo: VS.any().when("planOtherOrderForCurrentSupplier", {
                            is: (x) => x === true,
                            then: VS.stringMax(4000),
                            otherwise: VS.any().strip()
                        })
                    }), otherwise: VS.any().strip()
                }),
            }),
            qualification: VS.object({
                predictedExclusion: VS.requiredBoolean(),
                predictedExclusionInfo: VS.any().when("predictedExclusion", {is: (x) => x === true, then: VS.arrayRequired(), otherwise: VS.any().strip()}),
                participationConditions: VS.requiredBoolean(),
                participationConditionsInfo: VS.any().when("participationConditions", {is: (x) => x === true, then: VS.stringMax(10000), otherwise: VS.any().strip()}),
                art125Statement: VS.requiredBoolean(),
                inclusionSubjectiveEvidence: VS.stringMaxNoRq(4000),
                exclusionSubjectiveEvidence: VS.stringMaxNoRq(4000)
            }),
            objectiveEvidence: VS.object({
                objectiveEvidenceInfo: VS.stringMaxNoRq(4000),
                plansEvidence: VS.any(),
                plansEvidenceInfo: VS.any().when("plansEvidence", {is: (x) => x === true, then: VS.stringMax(4000), otherwise: VS.any().strip()}),
                otherDocumentsList: VS.stringMaxNoRq(4000)
            }),
            orderTerms: VS.object({
                variantsAllowed: VS.requiredBoolean(),
                variantsAllowedInfo: VS.any().when("variantsAllowed", {is: (x) => x === true, then: VS.string(), otherwise: VS.any().strip()}),
                auctionPlanned: VS.requiredBoolean(),
                auctionUrl: VS.any().when("auctionPlanned", {is: (x) => x === true, then: VS.stringMax(250), otherwise: VS.any().strip()}),
                auctionPlannedInfo: VS.any().when("auctionPlanned", {is: (x) => x === true, then: VS.stringMax(10000), otherwise: VS.any().strip()}),
                guaranteeRequired: VS.requiredBoolean(),
                guaranteeRequiredInfo: VS.any().when("guaranteeRequired", {is: (x) => x === true, then: VS.stringMax(4000), otherwise: VS.any().strip()}),
                properExecutionGuarantee: VS.requiredBoolean(),
                togetherRequirements: VS.stringMaxNoRq(4000),
                possibleDemandInvalidation: VS.requiredBoolean()
            }),
            contractDraft: VS.object({
                advancePayment: VS.requiredBoolean(),
                advancePaymentInfo: VS.any().when("advancePayment", {is: (x) => x === true, then: VS.stringMax(4000), otherwise: VS.any().strip()}),
                contractChanges: VS.requiredBoolean(),
                contractChangesInfo: VS.any().when("contractChanges", {is: (x) => x === true, then: VS.stringMax(4000), otherwise: VS.any().strip()}),
                socialAspects: VS.requiredBoolean(),
                socialAspectsInfo: VS.any().when("socialAspects", {is: (x) => x === true, then: VS.arrayRequired(), otherwise: VS.any().strip()})
            }),
            orderDetails: VS.object({
                x: VS.any().strip(),
                frameworkAgreement: VS.any().when("x", {
                    is: (x) => refersTo === "FrameworkAgreement",
                    then: VS.object({
                        suppliersNumber: VS.string(),
                        suppliersNumberLimited: VS.requiredBoolean(),
                        suppliersNumberLimit: VS.any().when("suppliersNumberLimited", {is: (x) => x === true, then: VS.number(), otherwise: VS.any().strip()}),
                        art314Order: VS.any().when("suppliersNumber", {
                            is: "FrameworkAgreementSeveralContractors",
                            then: VS.string(),
                            otherwise: VS.any().strip()
                        }),
                        periodExceedInfo: VS.any()
                    }).nullable(), otherwise: VS.any().strip()
                }),
                primary: VS.any().when("x", {
                    is: (x) => primaryRealizationType,
                    then: VS.object({
                        offerEndDate: VS.dateTimeValid(),
                        offerSubmitPlace: VS.string(),
                        offerOpenDate: VS.dateTimeValid(),
                        bindWithOffer: VS.any().when("offerSubmitPlace", {
                            is: (x) => realization_primary_1 || realization_primary_2,
                            then: VS.string(), otherwise: VS.any().strip()
                        }),
                        bindWithOfferDays: VS.any().when("bindWithOffer", {
                            is: (x) => x === "DAYCOUNT" && (realization_primary_1 || realization_primary_2),
                            then: VS.numberPositiveNoZero(),
                            otherwise: VS.any().strip()
                        }),
                        bindWithOfferDate: VS.any().when("bindWithOffer", {
                            is: (x) => x === "DATE" && (realization_primary_1 || realization_primary_2),
                            then: VS.dateTimeValid(),
                            otherwise: VS.any().strip()
                        }),
                        maxSupplierNumber: VS.any().when("offerSubmitPlace", {
                            is: (x) => realization_primary_2 || realization_primary_3,
                            then: VS.numberPositiveOptional(), otherwise: VS.any().strip()
                        }),
                        limitSuppliersNumberInfo: VS.any().when("offerSubmitPlace", {
                            is: (x) => realization_primary_2 || realization_primary_3,
                            then: VS.stringMaxNoRq(4000), otherwise: VS.any().strip()
                        }),
                        noNegotiationsTermsDescription: VS.any().when("offerSubmitPlace", {
                            is: (x) => realization_primary_3,
                            then: VS.string(4000)
                        }),
                    }), otherwise: VS.any().strip()
                }),
                primaryLots: VS.any().when("x", {
                    is: (x) => partialOffers === true && primaryRealizationType,
                    then: VS.arrayOf(primaryLotValidator), otherwise: VS.any().strip()
                }),
                primaryNoLots: VS.any().when("x", {
                    is: (x) => partialOffers === false && primaryRealizationType,
                    then: primaryLotValidator, otherwise: VS.any().strip()
                }),
                partnership: VS.any().when("x", {
                    is: (x) => realization_partnership_2,
                    then: VS.object({
                        offerEndDate: VS.dateTimeValid(),
                        offerSubmitPlace: VS.string(),
                        offerOpenDate: VS.dateTimeValid(),
                        phasedNegotiations: VS.requiredBoolean(),
                        suppliersLimited: VS.requiredBoolean(),
                        suppliersLimitedInfo: VS.any().when("suppliersLimited", {is: (x) => x === true, then: VS.string(4000), otherwise: VS.any().strip()}),
                        criteriaComplianceDeclaration: VS.any().when("suppliersLimited", {
                            is: (x) => x === true,
                            then: VS.requiredBoolean(),
                            otherwise: VS.any().strip()
                        }),
                        criteriaComplianceList: VS.any().when("suppliersLimited", {is: (x) => x === true, then: VS.string(4000), otherwise: VS.any().strip()}),
                        minSuppliersCount: VS.any().when("suppliersLimited", {
                            is: (x) => x === true,
                            then: VS.numberPositiveNoZero(),
                            otherwise: VS.any().strip()
                        }),
                        maxSuppliersCount: VS.any().when("suppliersLimited", {
                            is: (x) => x === true,
                            then: VS.numberPositiveNoZero(),
                            otherwise: VS.any().strip()
                        }),
                    }), otherwise: VS.any().strip()
                }),
                partnershipLots: VS.any().when("x", {
                    is: (x) => partialOffers === true && realization_partnership_2,
                    then: VS.arrayOf(partnershipLotValidator),
                    otherwise: VS.any().strip()
                }),
                partnershipNoLots: VS.any().when("x", {
                    is: (x) => partialOffers === false && realization_partnership_2,
                    then: partnershipLotValidator,
                    otherwise: VS.any().strip()
                })
            }),
            additionalInfo: VS.object({
                info: VS.stringMaxNoRq(4000)
            })
        })
    })
});